import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
    override getDateNames(): string[] {
        return super.getDateNames().map(name => name.replace(/\./g, ''));
    }

    override format(date: Date, displayFormat: Object): string {
        if (displayFormat === 'dd MMM yyyy') {
            return new Intl.DateTimeFormat(this.locale, {
                day: '2-digit',
                month: 'long',
                year: 'numeric'
            }).format(date);
        }

        if (displayFormat === 'MMM yyyy') {
            return new Intl.DateTimeFormat(this.locale, {
                month: 'short',
                year: 'numeric'
            }).format(date);
        }

        if (displayFormat === 'HH:mm') {
            const pad = (n: number) => n.toString().padStart(2, '0');
            return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
        }

        return super.format(date, displayFormat);
    }
}
